<template>
  <div class="sm:flex sm:items-center sm:justify-between">
    <div class="flex-1 min-w-0">
      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-2 mb-4">
        <div class="flex">
          <div class="ml-1">
            <p class="text-sm text-yellow-700">
              Эта страница содержит личные данные покупателя!
              Не делитесь этой ссылкой с третьими лицами!
            </p>
          </div>
        </div>
      </div>

      <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Заказ №{{ order.number }}
      </h2>

      <span v-if="order.api_client" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary text-white">
        {{ order.api_client.name }}
      </span>

      <p class="text-sm mt-2" v-if="dashboardPrefix && dashboardUrl">
        <a :href="dashboardUrl" class="text-primary underline">Открыть в админке</a>
      </p>

      <div class="mt-1 flex flex-col sm:flex-row sm:flex-wrap sm:mt-0 sm:space-x-6">
        <div class="mt-2 flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path></svg>
          {{ order.submitted_at.datetime_at }}
        </div>
        <div class="mt-2 flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
          </svg>
          {{ order.city.name }}
        </div>
        <div class="mt-2 flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
          {{ order.delivery_method.name }}
        </div>
        <div class="mt-2 flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd" />
          </svg>
          {{ order.total_price.full }}
        </div>
        <div class="mt-2 flex items-center text-sm text-gray-500">
          <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd" />
          </svg>
          <template v-if="order.deliver_at_local">Предзаказ {{ order.deliver_at_local.datetime_at }}</template>
          <template v-else>Как можно скорее</template>
        </div>
      </div>
    </div>
  </div>

  <h2 class="my-4 text-xl font-bold">Покупатель</h2>

  <customer :customer="order.customer" />

  <h2 class="mt-4 text-xl font-bold">Список товаров ({{ quantity }})</h2>
  <ul class="divide-y divide-gray-200">
    <li v-for="variant in order.variants" class="py-4 flex items-center gap-4">
      <product-variant :variant="variant" />
    </li>
  </ul>

  <template v-if="order.notes">
    <h2 class="my-4 text-xl font-bold">Комментарий покупателя</h2>
    <p class="text-sm" v-html="orderNotes"></p>
  </template>

  <template v-if="order.promocode">
    <h2 class="my-4 text-xl font-bold">Промокод</h2>
    <p class="text-sm max-w-full break-all">
      Покупатель ввёл промокод
      <strong>{{ order.promocode.promocode }}</strong>
    </p>
  </template>

  <h2 class="my-4 text-xl font-bold">Доставка</h2>
  <delivery-info :order="order" />

  <h2 class="my-4 text-xl font-bold">Оплата</h2>
  <payments-summary :order="order" />
</template>

<script>
import ProductVariant from '@/components/orders/ProductVariant'
import PaymentsSummary from '@/components/orders/PaymentsSummary'
import DeliveryInfo from '@/components/orders/DeliveryInfo'
import Customer from '@/components/orders/Customer'
import config from '@/zenky/config'

export default {
  props: {
    order: {
      required: true,
      type: Object,
    },

    dashboardPrefix: {
      required: true,
      type: String,
    },
  },

  components: {
    ProductVariant,
    PaymentsSummary,
    DeliveryInfo,
    Customer,
  },

  computed: {
    quantity() {
      return this.order.variants.reduce((total, current) => {
        if (current.has_measured_quantity) {
          return total + 1;
        }

        return total + current.quantity;
      }, 0)
    },

    orderNotes() {
      return this.order.notes.toString().replaceAll("\n", '<br>')
    },

    dashboardUrl() {
      return `${config.dashboard.url}/dashboard/${this.dashboardPrefix}/orders/${this.order.id}`
    },
  },
}
</script>
